module.exports = {"232701100":"西林吉镇","232701101":"图强镇","232701102":"阿木尔镇","232701103":"兴安镇","232701104":"北极镇","232701105":"古莲镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/232701.json
// module id = 899
// module chunks = 0